<template>
  <div class="audit-page">
    <h1 class="audit-title">Audit</h1>
    <p class="audit-lead">Events recorded for this account.</p>
    <p v-if="error" class="error--text">{{ error }}</p>
    <Loading :isLoading="loading && days.length === 0">
      <div v-if="!loading && days.length === 0 && !error" class="audit-empty">No audit events yet.</div>
      <v-timeline v-if="days.length" dense clipped class="audit-timeline pa-0">
        <TimelineDay v-for="(tlDay, tlDayIdx) in days" :day="tlDay" :key="tlDayIdx"></TimelineDay>
      </v-timeline>
      <v-btn
        v-if="days.length && !done"
        flat
        color="secondary"
        class="audit-more"
        :loading="loading"
        @click="loadMore"
      >Load older events</v-btn>
    </Loading>
  </div>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"
import TimelineDay from "@/components/timeline/TimelineDay.vue"
import Vue from "vue"

export default {
  name: "audit-log",
  components: { Loading, TimelineDay },
  data: () => ({
    days: [],
    loading: false,
    error: "",
    page: 0,
    pageSize: 50,
    done: false,
  }),
  mounted() {
    Vue.store.dispatch("setPageTitle", "Audit")
    this.load(false)
  },
  methods: {
    async load(append) {
      this.loading = true
      this.error = ""
      try {
        const next = await this.$store.state.provider.getAuditLog({
          page: this.page,
          pageSize: this.pageSize,
        })
        const rows = next || []
        if (append) {
          if (rows.length === 0) {
            this.done = true
          } else {
            this.days = this.days.concat(rows)
          }
        } else {
          this.days = rows
          this.done = rows.length === 0
        }
      } catch (err) {
        this.error = (err && err.message) || "Unable to load the audit log"
      } finally {
        this.loading = false
      }
    },
    loadMore() {
      if (this.done || this.loading) {
        return
      }
      this.page += 1
      this.load(true)
    },
  },
}
</script>

<style scoped>
.audit-page {
  background: #fff;
  margin-top: -60px;
  min-height: calc(100vh - 50px);
  padding: 36px 40px 64px;
}

.audit-title {
  margin: 0;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.2;
  color: #1d303e;
}

.audit-lead {
  margin: 8px 0 28px;
  color: rgba(29, 48, 62, 0.62);
}

.audit-empty {
  color: rgba(29, 48, 62, 0.62);
}

.audit-more {
  margin-top: 8px;
}
</style>

<style>
.audit-timeline .v-timeline-item__dot,
.audit-timeline .v-timeline-item__dot .v-timeline-item__inner-dot {
  background: #fff !important;
}
</style>
